import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiDataList, TuiScrollbar, TuiScrollable } from '@taiga-ui/core';
import { TuiDataListWrapper } from '@taiga-ui/kit';
import { ComponentsModule } from '@src/app/components';

import { PrivacyPageComponent } from './privacy-page.component';

@NgModule({
  declarations: [PrivacyPageComponent],
  imports: [
    CommonModule,
    TuiScrollbar,
    TuiScrollable,
    TuiSelectModule,
    ...TuiDataListWrapper,
    ...TuiDataList,
    TuiTextfieldControllerModule,
    FormsModule,
    ComponentsModule,
  ],
  exports: [PrivacyPageComponent],
})
export class PrivacyPageModule {}
